import styles from './part-design-elements-container.module.scss';

export { default } from './part-design-elements-container';

const designElementsParentContainerClass = styles.designElementsParentContainer;

export { designElementsParentContainerClass };
